import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {headerFeaturedArticlesEdit_template} from "../components/templates/headerFeaturedArticlesEdit_template";
import {header} from "./header";

import {string} from "@amcharts/amcharts4/core";

declare var ko: any;
declare var page: any;

export class header_featured_articles_edit extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected headerFeaturedArticlesEditTemplate: headerFeaturedArticlesEdit_template;
    protected pagination: pagination_template;
    protected XHRHdls: XMLHttpRequestHandler[] = [];

    buildContent(): Array<Element> {
        this.headerFeaturedArticlesEditTemplate = new headerFeaturedArticlesEdit_template("headerFeaturedArticlesEditTemplate", this.viewModel, this)
        return [this.headerFeaturedArticlesEditTemplate.build()];

    }

    protected getModuleName(): string {
        return "header_featured_articles_edit";
    }

    fillPage() : void{

        this.getFormData();
    }

    protected getFormData() {

        this.loadingIn(this.headerFeaturedArticlesEditTemplate.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let url: string = '/api/brand/' + idBrand + "/headerFeaturedArticlesList/get/";
        let params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();

    }
    protected getEditData(idFeaturedArticle){
        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let url: string = '/api/brand/' + idBrand + "/headerFeaturedArticles/get/"+idFeaturedArticle+"/";
        let params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetEditDataReturn;
        this.XHRHdl.execute();
    }
    protected  onGetEditDataReturn(req,obj){
        return function(){
            obj.manageResponse(req, obj, function() {

                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed.articles;
                let idCategory = responseParsed.idCategory;
                let categories = responseParsed.categories;
                obj.headerFeaturedArticlesEditTemplate.setCategories(categories);
                //obj.headerFeaturedArticlesEditTemplate.setIdCategory(idCategory);
                // obj.headerFeaturedArticlesEditTemplate.setOnClickEditPage(data);

                obj.headerFeaturedArticlesEditTemplate.setArticle(data);
            });
        }
    }

    public getSuggestions(keyword, idElement) {

        if(idElement == 'articleFilter'){
            this.getArticlesSuggestion(keyword,idElement)
        }
    }

    protected getArticlesSuggestion(keyword, idElement) {

        if( "getArticlesSuggestion" in this.XHRHdls ){
            this.XHRHdls["getArticlesSuggestion"].cancelAndReset();
        }

        let subViewModel = {list: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/article/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getArticlesSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls["getArticlesSuggestion"].onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
        this.XHRHdls["getArticlesSuggestion"].execute();
    }

    protected onGetArticlesSuggestionsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){


                let response = JSON.parse(req.request.response);

                if (response.data.articles) {
                    let articles = [];

                    for(let article of response.data.articles){

                        article.name = article.title;

                        articles.push(article);

                    }

                    obj.headerFeaturedArticlesEditTemplate.setArticleFilterAutocomplete(articles);
                }

            });
        }
    }

    protected onGetFormDataReturn(req, obj) {
        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                let categories = responseParsed.categories;
                let featuredArticles = responseParsed.articles;
                let categoriesWithoutDefault = responseParsed.categoriesWithoutDefault;
                featuredArticles = Object.keys(featuredArticles).map((key) => featuredArticles[key]);
                // //
                let p =0
                for(let n of featuredArticles){
                    let articles = n.articles;
                    // articles = Object.keys(articles).map((key) => articles[key]);
                    let m = 0;

                    // for( let i of articles){
                    //    i =  Object.keys(i).map((key) => i[key]);
                    //    articles[m] = i;
                    //    m ++;
                    // }
                    // featuredArticles[p].articles = articles;
                    p ++;
                    //set up the articles

                }
                // let objectKeys = Object.keys(featuredArticles);

                obj.headerFeaturedArticlesEditTemplate.setMenu(categories,featuredArticles,categoriesWithoutDefault);

            });
            obj.loadingOut(obj.headerFeaturedArticlesEditTemplate.builtTemplate);
            //obj.loadingOut(obj.headerFeaturedArticlesEditTemplate.builtTemplate.children.namedItem("list-results"));
        }

    }

    public viewEditPage(id){
        this.getEditData(id);
        // page('/brand/'+ this.getVnAppZone().app.params.idBrand +'/config/headerFeaturedArticles/edit/'+ id);
    }

    public viewMenuItems(id){
        page('/brand/'+ this.getVnAppZone().app.params.idBrand +'/config/menu/edit/'+ id);
    }

    protected save() {

        this.loadingIn(this.headerFeaturedArticlesEditTemplate.builtTemplate);

        this.clearValidationErrors();
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let idMenu = this.getVnAppZone().getApp().params.id;

        let formReq_url: string = '/api/brand/' + idBrand + "/headerFeaturedArticlesList/save/";

        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.viewModel));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        formReq_params.push(["menu",ko.toJSON({idMenu : idMenu})]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    // let responseParsed = JSON.parse(req.request.response);
                    // console.log(responseParsed)

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Header Articles saved successfully !");

                    page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand+ '/config/menu/');


                })
                obj.loadingOut(obj.headerFeaturedArticlesEditTemplate.builtTemplate);

            }
        });
        XHRHdl.execute();
    }

    public cancelForm() {
        this.cancel();
        page.redirect(this.getVnAppZone().app.getLastRoute());
    }

    protected cancel() {
        //this.getFormData();


        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Menu changes cancelled!");
        this.backAction();
    }


    protected backAction(){
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect("/brand/"+idBrand+"/config/menu/");
    }

    protected addArticle(){

        // if( this.XHRHdl ){
        //     this.XHRHdl.cancelAndReset();
        // }
        // this.saveViewModule(this.getMemoryViewModel());
        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/headerFeaturedArticles/add/')
    }
    protected getMemoryViewModel(){

        let templateViewModel = this.headerFeaturedArticlesEditTemplate.getTemplateViewModel();

        delete templateViewModel.articles;

        return templateViewModel;
    }
    protected onAutocompleteOptionChange(idElement) {

    }

    protected onAutocompleteInputClick(idElement){

    }

    protected onAutocompleteInputClear(idElement){

    }

    public clearValidationErrors(){

        this.validationTemplate.clearMessages();
        this.headerFeaturedArticlesEditTemplate.removeValidationClass();
    }

}



// WEBPACK FOOTER //
// ./js/modules/header_featured_articles_edit.ts